import { Box, Card, Radio } from '@nimbus-ds/components';
import './TaskRadioCard.scss';

interface TaskRadioCardProps {
  task: { id: number; code: string; description?: string; label: string };
  selectedId: number | null;
  onChange: (id: number) => void;
  name: string;
}

export function TaskRadioCard({
  task,
  selectedId,
  onChange,
  name,
}: Readonly<TaskRadioCardProps>) {
  return (
    <Card>
      <Box display="flex" alignItems="center">
        <div className="stratus--radio-shadow">
          <Radio
            label={task.label}
            name={name}
            id={`${name}-${task.id}`}
            value={task.id.toString()}
            checked={selectedId === task.id}
            onChange={(e) => {
              if (e.target.checked) {
                onChange(task.id);
              }
            }}
          />
        </div>
      </Box>
    </Card>
  );
}
